import React from 'react'
import Layout from '../../Layout/';
import PageTitle from '../../Layout/PageTitle';
import Meta from '../../UI/Meta';
import { Wrapper } from '../../UI';
import TenantTable from '../../MyPortfolio/Dashboard/TenantTable';
import data from '../../../utils/dbSchema';
import NavigateBack from '../../UI/NavigateBack';

export default function RentRoll({ match }) {
	const propertyData = data.properties.find(property => {
		return match.params.id === property.id;
    });
    
    return (
        <Layout>
            <Wrapper pt='30px'>
                <PageTitle title='Rent Roll' action={<NavigateBack slug={`/market-search/${propertyData.id}`} />}>
                    <Meta />
                </PageTitle>
                <TenantTable data={propertyData} />
            </Wrapper>
        </Layout>
    )
}
